import React, { useEffect, useState } from "react";
import "./RippleRunMarathonPage.css";

/* =========================================
   AUTO IMAGE LOADER (CRA / WEBPACK ONLY)
========================================= */

const importAll = (r) => r.keys().map(r);

const slides = importAll(
  require.context("../Assets/gallery", false, /\.(png|jpe?g|svg)$/)
);

/* =========================================
   COMPONENT
========================================= */

const RippleRunMarathonPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!slides.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="marathon-page">

      {/* HEADER */}
      <div className="marathon-header">
        <h1 className="marathon-title">
          Experience the Ripple Run Marathon Event
        </h1>

        <p className="marathon-subtitle">
          A journey of endurance, unity, and impact
        </p>
      </div>

      {/* SLIDER */}
      <div className="marathon-slider">

        {slides.map((img, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
          >
            <img
              src={img}
              alt={`Marathon ${index + 1}`}
              loading="lazy"
            />
          </div>
        ))}

      </div>

    </section>
  );
};

export default RippleRunMarathonPage;